import React from 'react'

const LccTables = ({comparedBids}) => {
  return (
    <div><div className='table-responsive'>
    <table className='table w-75 mx-auto mt-4 table-bordered'>
      <thead>
        <tr>
          <th className="comparasion-table-th">Applicable Losses</th>
          <th className="comparasion-table-th"> %</th>
          <th className="comparasion-table-th">in KW</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ISTS Losses</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.istsLoss[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.istsLoss[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>STU Losses - Seller</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.stuLossSeller[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.stuLossSeller[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Wheeling/Distribution Losses - Seller</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.distributionLossSeller[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.distributionLossSeller[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>STU Losses - Buyer</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.stuLossBuyer[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.stuLossBuyer[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Wheeling/Distribution Losses - Buyer</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.distributionLossBuyer[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.distributionLossBuyer[1] || 0)?.toFixed(2)}</td>
        </tr>
      </tbody>
      <tfoot className='cus-table-ftr'>
        <tr>
          <td colSpan={2}>Total Power at Premises</td>
          <td >{(comparedBids?.bidCapacity?.lcc?.applicableLosses?.totalPowerAtPremises || 0)?.toFixed(2)}</td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div className='table-responsive'>
    <table className='table w-75 mx-auto mt-4 table-bordered'>
      <thead>
        <tr>
          <th className="comparasion-table-th">Applicable Charges</th>
          <th className="comparasion-table-th">₹/kWh</th>
          <th className="comparasion-table-th">Amount (in ₹) </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>InterState POC Charges</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.interstatePocCharge[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.interstatePocCharge[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>STU Charges - Seller</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.stuChargeSeller[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.stuChargeSeller[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Wheeling/Distribution Charges-Seller</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.distributionChargeSeller[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.distributionChargeSeller[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>STU Charges - Buyer</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.stuChargeBuyer[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.stuChargeBuyer[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Wheeling/Distribution Charges-Buyer</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.distributionChargeBuyer[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.distributionChargeBuyer[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Cross Subsidy Surcharge</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.crossSubsidySurcharge[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.crossSubsidySurcharge[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Additional Surcharge</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.additionalSurcharge[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.additionalSurcharge[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Other Charges</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.otherCharges[0] || 0)?.toFixed(2)}</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.otherCharges[1] || 0)?.toFixed(2)}</td>
        </tr>
      </tbody>
      <tfoot >
        <tr>
          <td colSpan={2}>Total Charges(Third Party/PPA)</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.totalChargesThirdParty || 0)?.toFixed(2)}</td>
        </tr>
        {/* <tr>
          <td colSpan={2}>Total Charges(Own Captive)</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.applicableCharges?.totalChargesOwnCaptive || 0)?.toFixed(2)}</td>
        </tr> */}
      </tfoot>
    </table>
  </div>
  <div className='table-responsive'>
    <table className='table w-75 mx-auto mt-4 table-bordered'>
      <thead>
        <tr>
          <th className="comparasion-table-th">Renewal Purchase Obligation</th>
          <th className="comparasion-table-th"> %</th>
          <th className="comparasion-table-th">Amount in ₹</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Non Solar Obligation</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.renewalPurchaseObligations?.nonSolarObligation[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.renewalPurchaseObligations?.nonSolarObligation[1] || 0)?.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Solar Obligation</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.renewalPurchaseObligations?.solarObligation[0] || 0)?.toFixed(2)} %</td>
          <td>{(comparedBids?.bidCapacity?.lcc?.renewalPurchaseObligations?.solarObligation[1] || 0)?.toFixed(2)}</td>
        </tr>
      </tbody>
      <tfoot className='cus-table-ftr'>
        <tr>
          <td colSpan={2}>Total Obligation</td>
          <td >{(comparedBids?.bidCapacity?.lcc?.renewalPurchaseObligations?.totalObligation || 0)?.toFixed(2)}</td>
        </tr>
      </tfoot>
    </table>
  </div></div>
  )
}

export default LccTables